import {
  SAVE_TO_LOCAL,
  SAVE_AS_FILE,
  SAVE_TO_GOOGLE_DRIVE,
  SAVE_TO_IMANAGE,
  SAVE_TO_ONE_DRIVE,
  SAVE_TO_BOX,
  SAVE_TO_DROPBOX,
  SAVE_TO_PRIVATE_DRIVE,
  SAVE_TO_GOOGLE_DRIVE_CLASS,
  SAVE_TO_LOCAL_CLASS,
  SAVE_TO_ONE_DRIVE_CLASS,
  SAVE_TO_BOX_CLASS,
  SAVE_TO_DROPBOX_CLASS,
  SAVE_TO_PRIVATE_DRIVE_CLASS,
  SAVE_TO_FILE_CLASS, SAVE_FILE_BTN_HIDDEN_SLOT, SAVE_TO_IMANAGE_CLASS, 
  SAVE_TO_FOXIT_STORAGE, SAVE_TO_FOXIT_STORAGE_CLASS, 
} from '../constants/savefile.constants';
import {isCNDomain} from 'Utils/utils';

const buttonMap = {
  SAVE:{
    text: "phantom_online:toolbar.buttons.saveFile"
  },
  SAVE_TO_LOCAL:{
    text:"phantom_online:toolbar.buttons.saveToLocal"
  },
  SAVE_AS:{
    text:"phantom_online:toolbar.buttons.saveASFile"
  },
  SAVE_TO_FOXIT_STORAGE:{
    text:"phantom_online:toolbar.buttons.saveToFoxitStorage"
  },
  SAVE_TO_ONE_DRIVE:{
    text:"phantom_online:toolbar.buttons.saveToOneDrive"
  },
  SAVE_TO_BOX: {
    text:"phantom_online:toolbar.buttons.saveToBox"
  },
  SAVE_TO_DROPBOX:{
    text:"phantom_online:toolbar.buttons.saveToDropBox"
  },
  SAVE_TO_GOOGLE_DRIVE:{
    text:"phantom_online:toolbar.buttons.saveToGoogleDrive"
  },
  SAVE_TO_IMANAGE: {
    text:"phantom_online:toolbar.buttons.saveToImanage"
  },
  SAVE_TO_PRIVATE_DRIVE:{
    text:"phantom_online:toolbar.buttons.saveToPrivateDrive"
  }
}

export default function AddModule(isOnPremiseDeployMode) {
  //text={{pdf2word.title}}
  let template = `<ribbon-button name="download-file-button"  icon-class="fx-icon-file_save_as-32" text="phantom_online:toolbar.buttons.saveAs" @tooltip @var.self="$component">
  <dropdown name="save-file-button-list" class="fv__ui-toolbar-show-text-button" @tooltip tooltip-title="phantom_online:toolbar.buttons.saveAs" icon-class="fv__icon-toolbar-save" @cannotBeDisabled @on.selected="self.select($args[0])" selected="0">
    <dropdown-button ribbon-text="phantom_online:toolbar.buttons.saveAs" ribbon-icon="fx-icon-file_save_as-32" icon-class="${SAVE_TO_LOCAL_CLASS}" name="${SAVE_TO_LOCAL}" accept=".pdf">phantom_online:toolbar.buttons.saveToLocal</dropdown-button>
  </dropdown>
  </ribbon-button>`;

  if (!isOnPremiseDeployMode) {
    if(isCNDomain()){
      return { fragments:[] };
    } else {
    //text="${buttonMap.SAVE.text}"
    template = `<ribbon-button name="download-file-button" icon-class="fx-icon-file_save_as-32" text="${buttonMap.SAVE.text}" @tooltip @var.self="$component">
    <dropdown class="save-items fv__ui-toolbar-show-text-button" text="${buttonMap.SAVE.text}" separate="false" name="save-file-button-list" @tooltip tooltip-title="${buttonMap.SAVE.text}"  icon-class="fv__icon-toolbar-save" @on.selected="self.select($args[0])" selected="0">
                  <dropdown-button visible='false' ribbon-text="${buttonMap.SAVE.text}"  tooltip-title="${buttonMap.SAVE.text}" name="${SAVE_FILE_BTN_HIDDEN_SLOT}"></dropdown-button>
                  <dropdown-button ribbon-text="${buttonMap.SAVE.text}"  tooltip-title="${buttonMap.SAVE.text}" icon-class="new-save-local-icon ${SAVE_TO_LOCAL_CLASS}" name="${SAVE_TO_LOCAL}" accept=".pdf">${buttonMap.SAVE_TO_LOCAL.text}</dropdown-button>
                  <dropdown-button icon-class="${SAVE_TO_FILE_CLASS}" name="${SAVE_AS_FILE}" accept=".pdf">${buttonMap.SAVE_AS.text}</dropdown-button>
                  <dropdown-button icon-class="${SAVE_TO_FOXIT_STORAGE_CLASS}" name="${SAVE_TO_FOXIT_STORAGE}" accept=".pdf">${buttonMap.SAVE_TO_FOXIT_STORAGE.text}</dropdown-button>
                  <dropdown-button ribbon-text="phantom_online:toolbar.buttons.saveAs" icon-class="${SAVE_TO_ONE_DRIVE_CLASS}" name="${SAVE_TO_ONE_DRIVE}" accept=".pdf">${buttonMap.SAVE_TO_ONE_DRIVE.text}</dropdown-button>
                  <dropdown-button ribbon-text="phantom_online:toolbar.buttons.saveAs" icon-class="${SAVE_TO_BOX_CLASS}" name="${SAVE_TO_BOX}" accept=".pdf">${buttonMap.SAVE_TO_BOX.text}</dropdown-button>
                  <dropdown-button ribbon-text="phantom_online:toolbar.buttons.saveAs" icon-class="${SAVE_TO_DROPBOX_CLASS}" name="${SAVE_TO_DROPBOX}" accept=".pdf">${buttonMap.SAVE_TO_DROPBOX.text}</dropdown-button>
                  <dropdown-button ribbon-text="phantom_online:toolbar.buttons.saveAs" icon-class="${SAVE_TO_GOOGLE_DRIVE_CLASS}" name="${SAVE_TO_GOOGLE_DRIVE}" accept=".pdf"s>${buttonMap.SAVE_TO_GOOGLE_DRIVE.text}</dropdown-button>
                  <dropdown-button ribbon-text="phantom_online:toolbar.buttons.saveAs" icon-class="${SAVE_TO_IMANAGE_CLASS}" name="${SAVE_TO_IMANAGE}" accept=".pdf"s>${buttonMap.SAVE_TO_IMANAGE.text}</dropdown-button>
                  </dropdown>
                </ribbon-button>`;
    }
  } else {
    //text="${buttonMap.SAVE.text}"
    template = `<ribbon-button name="download-file-button" icon-class="fx-icon-file_save_as-32" text="${buttonMap.SAVE.text}" @tooltip @var.self="$component">
    <dropdown ribbon-icon="fx-icon-file_save_as-32" class="save-items fv__ui-toolbar-show-text-button"  text="${buttonMap.SAVE.text}" name="save-file-button-list" @tooltip tooltip-title="${buttonMap.SAVE.text}"  icon-class="fv__icon-toolbar-save" @on.selected="self.select($args[0])" selected="0">
                  <dropdown-button ribbon-text="${buttonMap.SAVE.text}" tooltip-title="${buttonMap.SAVE.text}" icon-class="${SAVE_TO_LOCAL_CLASS}" name="${SAVE_TO_LOCAL}" accept=".pdf">${buttonMap.SAVE_TO_LOCAL.text}</dropdown-button>
                  <dropdown-button ribbon-text="phantom_online:toolbar.buttons.saveAs" icon-class="${SAVE_TO_PRIVATE_DRIVE_CLASS}" name="${SAVE_TO_PRIVATE_DRIVE}" accept=".pdf">${buttonMap.SAVE_TO_PRIVATE_DRIVE.text}</dropdown-button>
                </dropdown>
                </ribbon-button>`;
                // <dropdown-button icon-class="${SAVE_TO_PRIVATE_DRIVE_S3_CLASS}" name="${SAVE_TO_PRIVATE_DRIVE_S3}" accept=".pdf">phantom_online:toolbar.buttons.saveToPrivateDriveS3</dropdown-button>
                // <dropdown-button icon-class="${SAVE_TO_PRIVATE_DRIVE_NFS_CLASS}" name="${SAVE_TO_PRIVATE_DRIVE_NFS}" accept=".pdf">phantom_online:toolbar.buttons.saveToPrivateDriveNFS</dropdown-button>
  }

  return template;
}
